export const summaryConfig = {
  /* -------------------------------- WEEKLY SUMMARIES ----------------------- */
  getWeeklySummaries: {
    key: "getWeeklySummaries",
    url: "/api/v1/review-summary/weekly",
    method: "GET",
    options: {
      staleTime: 60_000, // 1 minute
      gcTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    },
  },

  getWeeklySummaryDetail: {
    key: "getWeeklySummaryDetail",
    url: (data) => {
      const params = new URLSearchParams();
      if (data.year) params.set("year", data.year);
      if (data.week) params.set("week", data.week);
      const qs = params.toString();
      return `/api/v1/review-summary/weekly/${data.summaryId}${qs ? `?${qs}` : ""}`;
    },
    method: "GET",
    options: {
      staleTime: 60_000,
      gcTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      enabled: false,
    },
  },

  /* -------------------------------- MONTHLY SUMMARIES ---------------------- */
  getMonthlySummaries: {
    key: "getMonthlySummaries",
    url: "/api/v1/review-summary/monthly",
    method: "GET",
    options: {
      staleTime: 60_000,
      gcTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    },
  },

  getMonthlySummaryDetail: {
    key: "getMonthlySummaryDetail",
    url: (data) => {
      const params = new URLSearchParams();
      if (data.year) params.set("year", data.year);
      if (data.month) params.set("month", data.month);
      const qs = params.toString();
      return `/api/v1/review-summary/monthly/${data.summaryId}${qs ? `?${qs}` : ""}`;
    },
    method: "GET",
    options: {
      staleTime: 60_000,
      gcTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      enabled: false,
    },
  },

  /* -------------------------------- YEARLY SUMMARIES ----------------------- */
  getYearlySummaries: {
    key: "getYearlySummaries",
    url: "/api/v1/review-summary/yearly",
    method: "GET",
    options: {
      staleTime: 60_000,
      gcTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    },
  },

  getYearlySummaryDetail: {
    key: "getYearlySummaryDetail",
    url: (data) => {
      const params = new URLSearchParams();
      if (data.year) params.set("year", data.year);
      const qs = params.toString();
      return `/api/v1/review-summary/yearly/${data.summaryId}${qs ? `?${qs}` : ""}`;
    },
    method: "GET",
    options: {
      staleTime: 60_000,
      gcTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      enabled: false,
    },
  },
};
